<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    pendingOperations: (pendingOperations$ | async) ?? [],
    showActionRow: (showActionRow$ | async) ?? false,
    showPreview: (showPreview$ | async) ?? false,
    isTagSelected: (isTagSelected$ | async) ?? false,
    tagTypeSearch: tagTypeSearch$ | async,
    tagSearch: tagSearch$ | async
  }"
  >
</ng-container>

<ng-template
  #template
  let-showPreview="showPreview"
  let-pendingOperations="pendingOperations"
  let-showActionRow="showActionRow"
  let-isTagSelected="isTagSelected"
  let-tagTypeSearch="tagTypeSearch"
  let-tagSearch="tagSearch"
  >
  <div flexFill flexLayout="row" flexLayout.lt-md="column" flexLayoutAlign="start stretch" class="menu-container">
    <div
      flex="20"
      flex.lt-lg="30"
      flexLayout="column"
      flexLayoutAlign="start stretch"
      class="column"
      >
      <div
        flex="2.5rem"
        flexLayout="row"
        flexLayoutAlign="space-between center"
        class="menu-actions"
        [class.attention]="attentionTo('tagTypeSearch') | async"
        >
        <div flex>
          <vp-tag-search-input
            title="TagType Search"
            placeholder="Search Tag Types"
            [search]="tagTypeSearch"
            entity="TagType"
            [debounce]="100"
            >
          </vp-tag-search-input>
        </div>
      </div>
      <vp-tag-type-menu-selector
        flex
        class="selector-container"
        [class.attention]="attentionTo('tagTypeSelector') | async"
        >
      </vp-tag-type-menu-selector>
    </div>
    <div
      flex="20"
      flex.lt-lg="30"
      flexLayout="column"
      flexLayoutAlign="start stretch"
      class="column"
      >
      @if (isTagSelected) {
        <div
          flex="2.5rem"
          flexLayout="row"
          flexLayoutAlign="space-between center"
          class="menu-actions"
          >
          <div flex>
            <vp-tag-search-input
              title="Tag Search"
              [search]="tagSearch"
              placeholder="Search Tags"
              entity="Tag"
              [debounce]="100"
              >
            </vp-tag-search-input>
          </div>
          <mat-icon class="icon" (click)="addTag()">add</mat-icon>
        </div>
      }
      <vp-tag-menu-selector flex class="selector-container"></vp-tag-menu-selector>
    </div>
    <div flex flexLayout="column" flexLayoutAlign="start stretch" class="column">
      <div
        flex
        flexLayout="row"
        flexLayoutAlign="start stretch"
        class="content"
        flexLayoutGap="1rem"
        >
        <vp-tag-editor flex class="tag-editor"></vp-tag-editor>
        @if (showPreview && showActionRow) {
          <div
            flex="35"
            flexLayout="column"
            flexLayoutAlign="start stretch"
            >
            <div class="preview-header" flexLayout="row" flexLayoutAlign="space-between center">
              <span>Change Preview</span>
              <mat-icon (click)="closePreview()">close</mat-icon>
            </div>
            <pre
              flex
              class="json-preview"
              [innerHtml]="pendingOperations | prettyjson: [true, 2]"
            ></pre>
          </div>
        }
      </div>
      @if (showActionRow) {
        <div flex="3rem" flexLayout="row">
          <vp-tag-manager-action-row flexFill> </vp-tag-manager-action-row>
        </div>
      }
    </div>
  </div>
</ng-template>
